import { Route } from "@angular/router";
import { ResetPasswordRequestComponent } from "./reset-password-request.component";

export const ResetPasswordRequestRouting: Route = {
    path: 'reset-password-request',
    component: ResetPasswordRequestComponent
};